import { useState } from "react";
import api from "../../../services/api";
import { message } from "antd";

export const UploadStatus = {
  SUCCESS: "success",
  ERROR: "error",
  UPLOADING: "uploading",
  IDLE: "idle"
};

export const useFileUpload = () => {
  const [status, setStatus] = useState(UploadStatus.IDLE);
  const [filename, setFilename] = useState("");
  const [progress, setProgress] = useState(0);

  const upload = ({ file }) => {
    const formData = new FormData();
    formData.append("file", file);

    setStatus(UploadStatus.UPLOADING);
    setProgress(0);
    setFilename(file.name);

    api
      .post("/contratos/planilha-atualizacao-parcelas/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Content-Disposition": `attachment; filename=${file.name}`
        },
        onUploadProgress: event => {
          const progress = Math.round((event.loaded * 100) / event.total);

          setProgress(progress);
        }
      })
      .then(() => {
        setStatus(UploadStatus.SUCCESS);
        message.success("Upload realizado.");
      })
      .catch(err => {
        console.error(err);
        setStatus(UploadStatus.ERROR);
        message.error("Ocorreu um erro ao fazer upload do arquivo");
      });
  };

  return {
    status,
    progress,
    filename,
    upload
  };
};



// WEBPACK FOOTER //
// ./src/pages/Contratos/AtualizacaoParcelas/use-file-upload.js